import keyBy from "lodash/keyBy";
import { IAssociation } from "../../types/association/Association";
import * as types from "../actions/actionTypes";
import { GenericTransport } from "../api/baseApi";
import { IVenueState, InitialState } from "./state";

const handles = {
  [types.SHIFTS_GET_SHIFT_FULFILLED]: (state: IVenueState, { venues }) => ({
    ...state,
    map: { ...state.map, ...keyBy(venues, "_id") },
  }),
  [types.VENUES_GET_ALL_FULFILLED]: (state: IVenueState, venues) => ({
    ...state,
    map: { ...state.map, ...keyBy(venues, "_id") },
  }),
  [types.APPOINTMENTS_GET_PUBLISHED_FULFILLED]: (
    state: IVenueState,
    { venues },
  ) => ({ ...state, map: { ...state.map, ...keyBy(venues, "_id") } }),
  [types.ASSOCIATIONS_GET_MANAGEABLE_FULFILLED]: (
    state: IVenueState,
    associations: IAssociation[],
  ): IVenueState => ({
    ...state,
    byAssociation: {
      ...state.byAssociation,
      ...associations.reduce((prev, a) => ({ ...prev, [a._id]: a.venues }), {}),
    },
  }),
  [types.APPOINTMENTS_GET_BY_PERSON_FULFILLED]: (
    state: IVenueState,
    data: GenericTransport<any>,
  ) => ({
    ...state,
    map: { ...state.map, ...keyBy(data.venues, "_id") },
  }),
  [types.SHIFTS_GET_MANAGEABLE_FULFILLED]: (
    state: IVenueState,
    { venues, associations },
  ): IVenueState => ({
    ...state,
    map: { ...state.map, ...keyBy(venues, "_id") },
    byAssociation: {
      ...state.byAssociation,
      ...associations.reduce(
        (prev, a) => ({
          ...prev,
          [a._id]: a.venues || state.byAssociation?.[a._id],
        }),
        {},
      ),
    },
  }),
};

export default function venuesReducer(
  state: IVenueState = InitialState.venues,
  action,
) {
  return action.type && action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
